import z from 'zod'

const USER_ROLES = [
  'CorPatchAdmin',
  'InstituteAdmin',
  'Trainer',
  'Trainee',
  'Researcher',
  'Unknown',
] as const

export const allRoles = USER_ROLES

const UserRoleSchema = z.enum(USER_ROLES)

export type UserRole = z.infer<typeof UserRoleSchema>

/**
 * The UserRole type as an enum to avoid typos
 */
export const USERROLES: { [key in UserRole]: key } = {
  CorPatchAdmin: 'CorPatchAdmin',
  InstituteAdmin: 'InstituteAdmin',
  Trainer: 'Trainer',
  Trainee: 'Trainee',
  Researcher: 'Researcher',
  Unknown: 'Unknown',
}

/**
 * All available roles with different permissions. These roles are ordered in descending order of their permission priviledges
 * It is important that if you add a new role you respect this order because it is implied in other functions e.g. getMostProviledgedRole()
 */

/**
 *
 * @param roles a users roles
 * @returns the role with the highest permission priviledges
 */
export const getMostProviledgedRole = (roles: UserRole[]) => {
  for (const role of USER_ROLES) {
    if (roles.includes(role)) return role
  }

  return USERROLES.Unknown
}

/**
 *
 * @param requiredRoles array of roles of which at least one must be matched by the user
 * @param userRoles all roles of the user
 * @returns boolean if the user fulfills at least one of the required roles
 */
export const hasAnyRolesOf = (
  requiredRoles: UserRole[],
  userRoles: UserRole[]
) => {
  for (const role of userRoles) {
    if (requiredRoles.includes(role)) return true
  }

  return false
}

export function saveParseUserRole(
  input: unknown,
  fallback: UserRole = USERROLES.Unknown
): UserRole {
  const isUserRole = UserRoleSchema.safeParse(input).success
  return isUserRole ? (input as UserRole) : fallback
}

export function isUserRole(value: unknown): value is UserRole {
  return UserRoleSchema.safeParse(value).success
}
